import theme_default_fa_lei from "./theme_default_fa_lei.json";
import theme_default_fa_bir from "./theme_default_fa_bir.json";

const themes = {
  theme_default_fa_lei,
  theme_default_fa_bir,
};

export function getConfigObjectData(type: string, slug: string) {
  return themes[`${type}_${slug}_${CONFIG.league}_${CONFIG.tricode}`];
}
